// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/training_session_icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home (CoachHome) — club strip & player goals */
.home-club-strip {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 16px 16px;
  padding: 14px 18px;
  background: linear-gradient(135deg, rgba(8, 119, 188, 0.08) 0%, rgba(8, 119, 188, 0.02) 100%);
  border: 1px solid rgba(8, 119, 188, 0.2);
  border-radius: 12px;
  max-width: 900px;
}

.home-club-strip__logo {
  width: 56px;
  height: 56px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.home-club-strip__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.home-club-strip__label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--brand-primary, #0877bc);
}

.home-club-strip__name {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-color, #1a2b3c);
  line-height: 1.25;
}

.home-player-goals {
  margin: 0 16px 20px;
  max-width: 900px;
}

.home-player-goals__title {
  margin: 0 0 12px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a2b3c;
}

.home-player-goals__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 640px) {
  .home-player-goals__grid {
    grid-template-columns: 1fr 1fr;
  }
}

.home-player-goals__card {
  border-radius: 12px;
  padding: 16px 18px;
  border: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 2px 10px rgba(8, 55, 90, 0.06);
}

.home-player-goals__card--primary {
  border-color: rgba(8, 119, 188, 0.35);
  background: linear-gradient(160deg, #fff 0%, rgba(8, 119, 188, 0.06) 100%);
}

.home-player-goals__card--secondary {
  border-color: #e2e8f0;
}

.home-player-goals__badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #0877bc;
  margin-bottom: 8px;
}

.home-player-goals__value {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1a2b3c;
  line-height: 1.4;
}

.home-player-goals__list {
  margin: 0;
  padding-left: 1.1rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: #334155;
  line-height: 1.5;
}

.home-player-goals__list li {
  margin-bottom: 4px;
}

.home-role-picker {
  margin: 0 16px 16px;
  max-width: 900px;
}

.home-player-groups {
  margin: 0 16px 20px;
  max-width: 900px;
}

.home-player-groups__title {
  margin: 0 0 10px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a2b3c;
}

.home-player-groups__list {
  margin: 0;
  padding-left: 1.25rem;
  color: #334155;
  line-height: 1.6;
}

.home-player-new-session {
  margin: 0 16px 20px;
  max-width: 900px;
  width: calc(100% - 32px);
  border: 0;
  border-radius: 16px;
  padding: 16px 18px;
  font: inherit;
  font-weight: 700;
  color: #fff;
  background: var(--brand-primary, #0877bc);
  cursor: pointer;
  box-shadow: 0 10px 24px -8px color-mix(in srgb, var(--brand-primary, #0877bc) 55%, transparent);
}

.home-player-new-session:hover {
  transform: scale(1.01);
}

.home-player-new-session:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
}

.home-player-next-sessions {
  margin: 0 16px 20px;
  max-width: 900px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
}

.home-player-next-sessions__title {
  margin: 0 0 12px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a2b3c;
}

.home-player-next-sessions__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.home-player-next-sessions__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid #f1f5f9;
  background: transparent;
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.home-player-next-sessions__item:last-child {
  border-bottom: none;
}

.home-player-next-sessions__copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.home-player-next-sessions__go {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
}

.home-player-next-sessions__group {
  font-weight: 600;
  color: var(--brand-primary, #0877bc);
}

.home-player-next-sessions__meta {
  font-size: 0.9rem;
  color: #64748b;
}

.home-player-finalized-calendar {
  margin-top: 8px;
}

.home-player-finalized-calendar__hint {
  margin: 0 16px 12px;
  max-width: 900px;
  font-size: 0.9rem;
  color: #64748b;
}

.home-player-finalized {
  margin: 0 16px 24px;
  max-width: 900px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fafafa;
}

.home-player-finalized__title {
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 700;
}

.home-player-finalized__list {
  margin: 0;
  padding-left: 1.1rem;
  color: #334155;
}

.home-player-finalized__item {
  margin-bottom: 8px;
}

.home-player-finalized__group {
  font-weight: 600;
  margin-right: 8px;
}

.home-player-finalized-hint {
  margin: 0 16px 16px;
  max-width: 900px;
  font-size: 0.9rem;
  color: #64748b;
}

.home-player-finalized__empty,
.home-player-finalized__loading {
  margin: 0;
  font-size: 0.95rem;
  color: #64748b;
}

/* Premium Dynamic Bright/Dark theme for all home roles (player, coach, admin) */
.home-theme-root {
  --brand-primary: var(--Primary-Color, #0A84FF);
  position: relative;
  background: var(--bg-color) !important;
  color: var(--text-color) !important;
  min-height: 0;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "SF Compact Display", "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
  padding-bottom: 0;
  transition: background 0.3s ease, color 0.3s ease !important;
}

/* Soft athletic brand wash behind hero */
.home-theme-root .home-hero-wash {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 140px;
  z-index: 0;
  background: linear-gradient(
    165deg,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16) 0%,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04) 45%,
    transparent 75%
  );
}

.dark-mode .home-theme-root .home-hero-wash,
html.dark-mode .home-theme-root .home-hero-wash {
  background: linear-gradient(
    165deg,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) 0%,
    rgba(15, 23, 42, 0.55) 40%,
    transparent 80%
  );
}

.home-theme-root > *:not(.home-hero-wash):not(.home-dashboard-body__overlay) {
  position: relative;
  z-index: 1;
}

/* Header (role switcher + its menu) must paint above the Switch club card. */
.home-theme-root > .header {
  z-index: 5;
  overflow: visible;
}

.home-theme-root .home-header--compact.header {
  padding: 10px 12px !important;
  margin: 6px 8px 4px !important;
  justify-content: flex-end;
}

.home-theme-root .home-welcome-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 8px 12px 8px;
  padding: 8px 12px;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color, rgba(0, 0, 0, 0.08)));
  background:
    linear-gradient(
      120deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent) 0%,
      transparent 55%
    ),
    var(--surface-color, #fff);
  box-sizing: border-box;
  animation: homeHeroFadeUp 0.45s cubic-bezier(0.25, 1, 0.5, 1) both;
}

.home-theme-root .home-welcome-card__copy {
  min-width: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.home-theme-root .home-welcome-card__actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
}

.home-theme-root .home-welcome-card__eyebrow {
  margin: 0 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc) !important;
  line-height: 1.2 !important;
}

.home-theme-root .home-welcome-card__name {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 750;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--text-color, #111) !important;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes homeHeroFadeUp {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.home-theme-root h1,
.home-theme-root h2,
.home-theme-root h3,
.home-theme-root h4,
.home-theme-root h5,
.home-theme-root h6 {
  color: var(--text-color) !important;
  transition: color 0.3s ease !important;
}

.home-theme-root p {
  color: var(--text-secondary) !important;
  transition: color 0.3s ease !important;
}

/* Navigation Header glass reskin */
.home-theme-root .header {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 16px !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  padding: 16px 20px !important;
  margin: 12px 16px 16px !important;
  color: var(--text-color) !important;
  transition: all 0.3s ease !important;
}

.home-theme-root .header-info > h3 {
  color: var(--text-color) !important;
  font-size: 18px !important;
  font-weight: 700 !important;
}

.home-theme-root .header-info > h3 span {
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .header-info > p {
  color: var(--text-secondary) !important;
}

.home-theme-root .clublogo,
.home-theme-root .header-role-btn {
  border: 1px solid var(--border-color) !important;
  background: var(--surface-color) !important;
  box-shadow: 0 4px 10px var(--shadow-color) !important;
}

.home-theme-root .header-role-menu,
.home-theme-root .header-role-menu--portal {
  z-index: 12050;
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  color: var(--text-color) !important;
}

.home-theme-root .notification-btn {
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  color: var(--text-color) !important;
  transition: all 0.2s ease;
}

.home-theme-root .notification-btn:hover {
  background: var(--border-color) !important;
  border-color: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.4) !important;
}

/* Material UI Dropdown Role Picker Reskin */
.home-theme-root .home-role-picker .MuiOutlinedInput-root {
  color: var(--text-color) !important;
  border-radius: 12px !important;
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
}

.home-theme-root .home-role-picker .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-color) !important;
}

.home-theme-root .home-role-picker .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.5) !important;
}

.home-theme-root .home-role-picker .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .home-role-picker .MuiInputLabel-root {
  color: var(--text-secondary) !important;
}

.home-theme-root .home-role-picker .MuiInputLabel-root.Mui-focused {
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .home-role-picker .MuiSvgIcon-root {
  color: var(--text-secondary) !important;
}

/* Club Strip Card Reskin */
.home-theme-root .home-club-strip {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  border-radius: 16px !important;
  margin: 0 16px 16px;
  transition: all 0.3s ease !important;
}

.home-theme-root .home-club-strip__logo {
  border: 1px solid var(--border-color) !important;
  background: var(--surface-color) !important;
  padding: 6px !important;
  box-shadow: 0 4px 12px var(--shadow-color) !important;
}

.home-theme-root .home-club-strip__label {
  color: var(--brand-primary, #0A84FF) !important;
  font-weight: 700;
}

.home-theme-root .home-club-strip__name {
  color: var(--text-color) !important;
}

/* Brand primary can be a dark club color — keep label readable on dark cards */
.dark-mode .home-theme-root .home-club-strip__label,
html.dark-mode .home-theme-root .home-club-strip__label {
  color: var(--brand-primary-light, var(--brand-primary, #0A84FF)) !important;
}

.home-theme-root .home-player-goals__card {
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  box-shadow: 0 8px 24px var(--shadow-color) !important;
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.3s ease !important;
}

.home-theme-root .home-player-goals__card:hover {
  transform: translateY(-2px);
}

.home-theme-root .home-player-goals__card--primary {
  background: linear-gradient(
    160deg,
    var(--surface-color) 0%,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) 100%
  ) !important;
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) !important;
}

.home-theme-root .home-player-goals__badge {
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .home-player-goals__value,
.home-theme-root .home-player-goals__title,
.home-theme-root .home-player-goals__list {
  color: var(--text-color) !important;
}

.home-theme-root .metrics-container {
  animation: homeMetricsStagger 0.55s cubic-bezier(0.25, 1, 0.5, 1) 0.08s both;
}

@keyframes homeMetricsStagger {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .home-theme-root .home-welcome-card,
  .home-theme-root .metrics-container {
    animation: none !important;
  }
}

.dark-mode .home-theme-root .home-welcome-card,
html.dark-mode .home-theme-root .home-welcome-card {
  background:
    linear-gradient(
      120deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent) 0%,
      transparent 55%
    ),
    var(--surface-color, #1a1a1a);
}

/* Player Groups List Badge Capsule Reskin */
.home-theme-root .home-player-groups {
  margin: 0 16px 20px;
}

.home-theme-root .home-player-groups__title {
  color: var(--text-color) !important;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.home-theme-root .home-player-groups__list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none !important;
  padding: 0 !important;
  margin: 12px 0 0 0 !important;
}

.home-theme-root .home-player-groups__list li,
.home-theme-root .home-player-groups__card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--surface-color) !important;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0A84FF) 20%, var(--border-color)) !important;
  color: var(--text-color) !important;
  font-weight: 650;
  font-size: 13px;
  padding: 8px 14px 8px 8px;
  border-radius: 14px;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0A84FF) 10%, transparent) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.home-player-groups__mark {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  background: linear-gradient(160deg, var(--brand-primary, #0877BC), color-mix(in srgb, var(--brand-primary, #0877BC) 55%, #081018));
  color: #fff;
  font-size: 13px;
  font-weight: 750;
  text-transform: uppercase;
}

.home-player-groups__name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-theme-root .home-player-groups__list li:hover,
.home-theme-root .home-player-groups__card:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--brand-primary, #0A84FF) 45%, var(--border-color)) !important;
  box-shadow: 0 10px 22px color-mix(in srgb, var(--brand-primary, #0A84FF) 16%, transparent) !important;
}

/* Year Metrics Slider Reskin */
.home-theme-root .metrics-info h3 {
  color: var(--text-color) !important;
  font-size: 16px;
  font-weight: 700;
}

.home-theme-root .slideData {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  color: var(--text-color) !important;
  border-radius: 16px !important;
  margin: 15px 10px;
  min-height: 148px !important;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.home-theme-root .slideData:hover {
  transform: translateY(-4px) !important;
  border-color: var(--brand-primary, #0A84FF) !important;
  box-shadow: 0 12px 40px 0 var(--shadow-color) !important;
}

.home-theme-root .metrics-container .slideData h3 {
  color: var(--text-secondary) !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  line-height: 1.25 !important;
  min-height: 2.5em;
  display: flex;
  align-items: center;
  word-break: break-word;
  hyphens: auto;
}

.home-theme-root .slideData p.card-info-main {
  color: var(--text-color) !important;
  font-weight: 800 !important;
  font-size: 32px !important;
  letter-spacing: -1px;
}

.home-theme-root .metric-icon {
  background: linear-gradient(135deg, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.15) 0%, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.03) 100%) !important;
  border: 2px solid rgba(var(--brand-primary-rgb, 10, 132, 255), 0.3) !important;
  box-shadow: 0 4px 15px rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) !important;
}

.home-theme-root .metric-icon svg {
  color: var(--brand-primary, #0A84FF) !important;
}

/* Slider navigation arrows and dots */
.home-theme-root .react-slideshow-container .nav:first-of-type,
.home-theme-root .react-slideshow-container .default-nav:last-of-type {
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 4px 12px var(--shadow-color) !important;
}

.home-theme-root .react-slideshow-container .nav:first-of-type svg,
.home-theme-root .react-slideshow-container .default-nav:last-of-type svg {
  fill: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .react-slideshow-container + .indicators .each-slideshow-indicator::before {
  background: var(--border-color) !important;
}

.home-theme-root .react-slideshow-container + .indicators .each-slideshow-indicator.active::before {
  background: var(--brand-primary, #0A84FF) !important;
}

/* Training Objectives Cards */
.home-theme-root .home-player-goals__title {
  color: var(--text-color) !important;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.home-theme-root .home-player-goals__card {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  border-radius: 16px !important;
  color: var(--text-color) !important;
  transition: all 0.3s ease !important;
}

.home-theme-root .home-player-goals__card--primary {
  border: 1px solid rgba(var(--brand-primary-rgb, 10, 132, 255), 0.35) !important;
  background: linear-gradient(160deg, var(--surface-color) 0%, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) 100%) !important;
  box-shadow: 0 8px 32px 0 rgba(var(--brand-primary-rgb, 10, 132, 255), 0.12) !important;
}

.home-theme-root .home-player-goals__badge {
  color: var(--brand-primary, #0A84FF) !important;
  font-weight: 700;
  font-size: 11px;
}

.home-theme-root .home-player-goals__value {
  color: var(--text-color) !important;
  font-weight: 600;
}

.home-theme-root .home-player-goals__list {
  color: var(--text-color) !important;
}

/* Material-UI PlayerLastSessionCard Glass Reskin */
.home-theme-root .MuiCard-root {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  color: var(--text-color) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
}

.home-theme-root .MuiCard-root > .MuiBox-root:first-of-type {
  background: linear-gradient(135deg, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.15) 0%, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.05) 100%) !important;
  border-bottom: 1px solid var(--border-color) !important;
  color: var(--text-color) !important;
}

.home-theme-root .MuiCard-root .MuiTypography-root {
  color: var(--text-color) !important;
}

.home-theme-root .MuiCard-root .MuiTypography-caption {
  color: var(--text-secondary) !important;
}

.home-theme-root .MuiCard-root .MuiDivider-root {
  border-color: var(--border-color) !important;
}

.home-theme-root .MuiCard-root .MuiIconButton-root {
  color: var(--text-color) !important;
  background: var(--bg-color) !important;
  border: 1px solid var(--border-color) !important;
}

.home-theme-root .MuiCard-root .MuiIconButton-root:hover {
  background: var(--border-color) !important;
}

.home-theme-root .MuiCard-root .MuiChip-root {
  background: var(--border-color) !important;
  color: var(--text-color) !important;
  border: 1px solid var(--border-color) !important;
}

.home-theme-root .MuiCard-root .MuiChip-root[style*="color"] {
  background: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) !important;
}

.home-theme-root .MuiCard-root svg {
  color: var(--brand-primary, #0A84FF) !important;
}

/* Next Sessions Section */
.home-theme-root .home-player-next-sessions {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
}

.home-theme-root .home-player-next-sessions__title {
  color: var(--text-color) !important;
  font-size: 16px;
  font-weight: 700;
}

.home-theme-root .home-player-next-sessions__group {
  color: var(--brand-primary, #0A84FF) !important;
  font-weight: 700 !important;
}

.home-theme-root .home-player-next-sessions__meta {
  color: var(--text-secondary) !important;
}

.home-theme-root .home-player-next-sessions__item {
  border-bottom: 1px solid var(--border-color) !important;
}

.home-theme-root .home-player-next-sessions__item:hover {
  color: var(--text-color);
}

.home-theme-root .home-player-next-sessions__go {
  color: var(--brand-primary, #0A84FF) !important;
}

/* DatePicker Calendar Glass Overrides */
.home-theme-root .home-player-finalized-calendar__hint {
  color: var(--text-secondary) !important;
}

.home-theme-root .home-player-finalized-calendar > div[style*="background-color"] {
  background-color: var(--surface-color) !important;
  color: var(--text-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 16px !important;
}

.home-theme-root .rdrCalendarWrapper {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  border-radius: 16px !important;
  color: var(--text-color) !important;
  transition: all 0.3s ease !important;
}

.home-theme-root .rdrMonthAndYearPickers select {
  color: var(--text-color) !important;
  background: transparent !important;
}

.home-theme-root .rdrMonthAndYearPickers select option {
  background-color: var(--surface-color) !important;
  color: var(--text-color) !important;
}

.home-theme-root .rdrMonthAndYearPickers {
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .rdrWeekDay {
  color: var(--text-secondary) !important;
}

.home-theme-root .rdrDayNumber span {
  color: var(--text-color) !important;
}

.home-theme-root .rdrDayPassive .rdrDayNumber span {
  color: var(--text-secondary) !important;
  opacity: 0.3 !important;
}

.home-theme-root .rdrNextPrevButton {
  background: var(--bg-color) !important;
}

.home-theme-root .rdrNextButton i {
  border-color: transparent transparent transparent var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .rdrPprevButton i {
  border-color: transparent var(--brand-primary, #0A84FF) transparent transparent !important;
}

.home-theme-root .rdrSelected,
.home-theme-root .rdrDaySelected {
  background: var(--brand-primary, #0A84FF) !important;
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .rdrSelected ~ .rdrDayNumber span,
.home-theme-root .rdrDaySelected .rdrDayNumber span {
  color: #ffffff !important;
  font-weight: 700;
}

/* Sessions Card Overrides under Player Home */
.home-theme-root .sessionselectedgrp {
  color: var(--text-color) !important;
  font-size: 16px !important;
  font-weight: 700 !important;
}

.home-theme-root .sessions-list > li,
.home-theme-root .sessions-list ul li {
  background: var(--surface-color) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;
  color: var(--text-color) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
}

.home-theme-root .sessions-list .session-info h3 {
  color: var(--text-color) !important;
  font-weight: 700 !important;
}

.home-theme-root .sessions-list .session-info p {
  color: var(--text-secondary) !important;
}

.home-theme-root .session-start {
  color: var(--text-color) !important;
}

.home-theme-root .deactive_btn {
  background-color: #FF453A !important;
  border-radius: 8px !important;
}

.home-theme-root .session_edit p {
  background: var(--bg-color) !important;
  border: 1px solid var(--border-color) !important;
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .session_edit p:hover {
  background: var(--border-color) !important;
  border-color: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.4) !important;
  box-shadow: 0 4px 15px rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) !important;
}

/* State highlights */
.home-theme-root .sessions-list ul li.home-session-card.scheduled {
  border-color: var(--border-color) !important;
  background: var(--surface-color) !important;
}

.home-theme-root .sessions-list ul li.home-session-card.running {
  border: 2px solid #30D158 !important;
  box-shadow: 0 0 15px rgba(48, 209, 88, 0.25) !important;
}

.home-theme-root .sessions-list ul li.home-session-card.paused {
  border: 2px solid #FF9F0A !important;
  box-shadow: 0 0 15px rgba(255, 159, 10, 0.25) !important;
}

.home-theme-root .sessions-list ul li.home-session-card.finalized {
  border: 2px solid var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .sessions-list ul li.home-session-card.active,
.home-theme-root .sessions-list ul li.home-session-card.home-session-card--selected {
  border: 2px solid var(--brand-primary, #0A84FF) !important;
  background: color-mix(
    in srgb,
    var(--brand-primary, #0A84FF) 18%,
    var(--surface-color)
  ) !important;
  box-shadow:
    0 0 0 3px color-mix(in srgb, var(--brand-primary, #0A84FF) 40%, transparent),
    0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 28%, transparent) !important;
}

/* Shared hint banner above calendar (replaces inline light-gray boxes) */
.home-date-hint {
  padding: 15px 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
  margin: 0 16px 15px;
  max-width: 900px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 4px 16px var(--shadow-color);
}

/* Section headings (metrics, training groups, etc.) */
.home-theme-root .home-info > h3,
.home-theme-root .metrics-info h3 {
  color: var(--text-color) !important;
}

.home-theme-root .sessionselectedgrp {
  color: var(--text-color) !important;
}

.home-theme-root .sessionselectedgrp span {
  color: var(--text-secondary) !important;
}

.home-theme-root .slideData p.card-info-unit,
.home-theme-root .metrics-container .slideData p.update-date {
  color: var(--text-secondary) !important;
}

.home-theme-root .slideData:hover .card-info h3,
.home-theme-root .slideData:hover .card-info p {
  color: var(--text-color) !important;
}

/* Training group slider cards */
.home-theme-root .Groupcard {
  background: var(--surface-color) !important;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0A84FF) 18%, var(--border-color)) !important;
  box-shadow: 0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 14%, transparent) !important;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease !important;
}

.home-theme-root .Groupcard:hover {
  border-color: color-mix(in srgb, var(--brand-primary, #0A84FF) 42%, var(--border-color)) !important;
}

.home-theme-root .selectedgrp,
.home-theme-root .Groupcard.groupcard--selected {
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0A84FF) 55%, var(--border-color)) !important;
}

.home-theme-root .group_name p {
  color: var(--text-color) !important;
}

.home-theme-root .groupcard__lane-val {
  color: var(--text-color);
}

.home-theme-root .groupcard__lane-lbl {
  color: var(--text-secondary);
}

.home-theme-root .groups-slider-container .indicators .each-slideshow-indicator::before {
  background: color-mix(in srgb, var(--brand-primary, #0A84FF) 35%, var(--border-color)) !important;
}

.home-theme-root .groups-slider-container .indicators .each-slideshow-indicator.active::before {
  background: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .ImageOverlay,
.home-theme-root .groupcard__media {
  background:
    radial-gradient(120% 90% at 12% 110%, color-mix(in srgb, var(--brand-primary, #0A84FF) 38%, transparent) 0%, transparent 58%),
    linear-gradient(165deg, color-mix(in srgb, var(--brand-primary, #0A84FF) 22%, #0b1f33) 0%, #102a44 100%) !important;
}

.home-theme-root .sliderinfoheading {
  color: var(--brand-primary, #0A84FF) !important;
}

.home-theme-root .sliderinfosheading {
  color: var(--text-color) !important;
}

.home-theme-root .sliderinfotheading,
.home-theme-root .slideInfoPStyle {
  color: var(--text-secondary) !important;
}

.home-theme-root .previmgslider circle,
.home-theme-root .nextimgslider circle {
  fill: var(--surface-color) !important;
  stroke: var(--border-color) !important;
}

/* Compact coach density: shrink groups + today's sessions above the fold */
.home-theme-root .metrics {
  margin: 2px 8px 4px;
}

.home-theme-root .home-info {
  padding: 2px 10px 4px;
}

.home-theme-root .home-info > h3 {
  font-size: 13px !important;
  line-height: 20px !important;
  margin: 0 !important;
}

.home-theme-root .groups-slider-container {
  padding: 0 2px 2px;
}

.home-theme-root .groups-slider-container .Groupcard {
  margin: 4px 6px;
}

.home-theme-root .groupcard__body {
  padding: 10px 12px 10px 14px !important;
}

.home-theme-root .groupcard__media {
  min-height: 72px !important;
  height: 72px !important;
}

.home-theme-root .calendar-and-add-section {
  margin: 8px auto 12px;
}

.home-theme-root .calendar-wrapper {
  max-width: 420px;
}

.home-theme-root .date-range-picker__toggle {
  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, var(--brand-primary, #0877BC) 12%, var(--surface-color)) 0%,
      var(--surface-color) 72%
    );
}

.home-theme-root .date-range-picker__kicker {
  font-size: 13px !important;
  line-height: 20px !important;
  color: var(--text-color) !important;
}

.home-theme-root .date-range-picker__value {
  font-size: 13px !important;
  line-height: 20px !important;
}

.home-theme-root .hts .home-info {
  padding: 2px 10px 4px;
}

.home-theme-root .hts .home-info > h3 {
  font-size: 13px !important;
  line-height: 20px !important;
  margin: 0 !important;
  color: var(--text-color) !important;
}

.home-theme-root .hts .hts__count {
  font-size: 13px !important;
  line-height: 20px !important;
}

.home-theme-root .home-date-sessions-with-calendar {
  width: 100%;
}

.home-theme-root .today-sessions {
  margin: 2px 8px !important;
}

/* Today's training sessions cards (coach/admin) — compact */
.home-theme-root .today-sessions .slideData.session-card {
  gap: 10px !important;
  padding: 10px 12px 10px 96px !important;
  margin: 6px 6px !important;
  min-height: 96px !important;
  height: auto !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent) !important;
  background-color: var(--surface-color) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    linear-gradient(
      135deg,
      var(--surface-color) 0%,
      color-mix(in srgb, var(--brand-primary-rgb, 10, 132, 255) 8%, var(--surface-color)) 100%
    ) !important;
  background-size: 84px 100%, cover !important;
  border: 1px solid var(--border-color) !important;
  color: var(--text-color) !important;
}

.home-theme-root .today-sessions .slideData.session-card .session-info.card-info {
  gap: 2px !important;
}

.home-theme-root .today-sessions .slideData.session-card .session-info h3 {
  font-size: 14px !important;
  margin: 0 0 2px !important;
  line-height: 1.25 !important;
  color: var(--text-color) !important;
}

.home-theme-root .today-sessions .slideData.session-card .session-info p {
  font-size: 12px !important;
  margin: 0 !important;
  line-height: 1.3 !important;
  color: var(--text-secondary) !important;
}

.home-theme-root .today-sessions .metrics-info h3,
.home-theme-root .today-sessions .home-info h3 {
  color: var(--text-color) !important;
}

/* Loading / empty states follow active theme */
.home-theme-root .home-sessions-loading-state {
  color: var(--text-secondary) !important;
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
}

.home-theme-root .home-sessions-empty-state {
  color: var(--text-secondary) !important;
  background: var(--surface-color) !important;
  border: 1px dashed var(--border-color) !important;
}

.home-theme-root .home-sessions-loading-spinner {
  border-color: color-mix(in srgb, var(--text-color) 15%, transparent) !important;
}

/* Role/refresh loading: overlay the dashboard body only, keep header/club strip */
.home-theme-root .home-dashboard-body {
  position: relative;
  min-height: calc(100dvh - 220px);
}

.home-theme-root .home-dashboard-body__content {
  transition: opacity 180ms var(--ease-premium, cubic-bezier(0.16, 1, 0.3, 1));
}

.home-theme-root .home-dashboard-body.is-loading .home-dashboard-body__content {
  pointer-events: none;
}

.home-theme-root .home-dashboard-body.is-loading:not(.has-stale-content) .home-dashboard-body__content {
  opacity: 0;
}

.home-theme-root .home-dashboard-body.has-stale-content .home-dashboard-body__content {
  opacity: 0.45;
}

.home-theme-root .home-dashboard-body__overlay {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  background: color-mix(in srgb, var(--bg-color, #0b0f19) 86%, transparent);
  animation: homeOverlayIn 180ms var(--ease-premium, cubic-bezier(0.16, 1, 0.3, 1)) both;
}

.home-theme-root .home-dashboard-body.is-loading:not(.has-stale-content) .home-dashboard-body__overlay {
  background: var(--bg-color, #0b0f19);
}

@keyframes homeOverlayIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,6FAA6F;EAC7F,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,eAAe;EACf,+FAA+F;AACjG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,SAAS;EACT,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,aAAa;EACb,kKAAkK;EAClK,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,UAAU;EACV;;;;;GAKC;AACH;;AAEA;;EAEE;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iHAAiH;EACjH;;;;;;8BAM4B;EAC5B,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;;;EAME,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA,mCAAmC;AACnC;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,8BAA8B;EAC9B,uDAAuD;EACvD,6BAA6B;EAC7B,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,gDAAgD;EAChD,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;;EAEE,cAAc;EACd,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0EAA0E;AAC5E;;AAEA,4CAA4C;AAC5C;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA,2BAA2B;AAC3B;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,2CAA2C;EAC3C,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,+EAA+E;AAC/E;;EAEE,2EAA2E;AAC7E;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,qDAAqD;EACrD;mCACiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;;;;cAIY;EACZ,0EAA0E;AAC5E;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;;;;;;iCAM+B;AACjC;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,uGAAuG;EACvG,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,oGAAoG;EACpG,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kIAAkI;EAClI,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,mGAAmG;EACnG,qGAAqG;AACvG;;AAEA,+BAA+B;AAC/B;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,mCAAmC;EACnC,8BAA8B;EAC9B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,sCAAsC;EACtC,sDAAsD;EACtD,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,8JAA8J;EAC9J,8EAA8E;EAC9E,mFAAmF;AACrF;;AAEA;EACE,+CAA+C;AACjD;;AAEA,sCAAsC;AACtC;;EAEE,2CAA2C;EAC3C,gDAAgD;EAChD,qDAAqD;AACvD;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;AACtD;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,+EAA+E;EAC/E,+HAA+H;EAC/H,sFAAsF;AACxF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mDAAmD;AACnD;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,mCAAmC;EACnC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8JAA8J;EAC9J,uDAAuD;EACvD,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;;AAEA,wCAAwC;AACxC;EACE,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;;EAEE,oDAAoD;EACpD,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,uDAAuD;EACvD,mCAAmC;EACnC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;EAC1C,0EAA0E;EAC1E,mFAAmF;AACrF;;AAEA,qBAAqB;AACrB;EACE,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;EAEE,0DAA0D;EAC1D;;;;cAIY;EACZ;;6FAE2F;AAC7F;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,sDAAsD;AACtD;;EAEE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,gCAAgC;AAChC;EACE,2CAA2C;EAC3C,uGAAuG;EACvG,qGAAqG;EACrG,2FAA2F;AAC7F;;AAEA;EACE,mGAAmG;AACrG;;AAEA;;EAEE,uGAAuG;AACzG;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE;;uHAEqH;AACvH;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;;KAKG;AACL;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,oGAAoG;EACpG,iDAAiD;EACjD;;;;;gBAKc;EACd,4CAA4C;EAC5C,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,+CAA+C;AAC/C;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,+EAA+E;AACjF;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yEAAyE;EACzE,sFAAsF;AACxF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Home (CoachHome) — club strip & player goals */\n.home-club-strip {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0 16px 16px;\n  padding: 14px 18px;\n  background: linear-gradient(135deg, rgba(8, 119, 188, 0.08) 0%, rgba(8, 119, 188, 0.02) 100%);\n  border: 1px solid rgba(8, 119, 188, 0.2);\n  border-radius: 12px;\n  max-width: 900px;\n}\n\n.home-club-strip__logo {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #fff;\n  padding: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.home-club-strip__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.home-club-strip__label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--brand-primary, #0877bc);\n}\n\n.home-club-strip__name {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-color, #1a2b3c);\n  line-height: 1.25;\n}\n\n.home-player-goals {\n  margin: 0 16px 20px;\n  max-width: 900px;\n}\n\n.home-player-goals__title {\n  margin: 0 0 12px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #1a2b3c;\n}\n\n.home-player-goals__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n@media (min-width: 640px) {\n  .home-player-goals__grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.home-player-goals__card {\n  border-radius: 12px;\n  padding: 16px 18px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  box-shadow: 0 2px 10px rgba(8, 55, 90, 0.06);\n}\n\n.home-player-goals__card--primary {\n  border-color: rgba(8, 119, 188, 0.35);\n  background: linear-gradient(160deg, #fff 0%, rgba(8, 119, 188, 0.06) 100%);\n}\n\n.home-player-goals__card--secondary {\n  border-color: #e2e8f0;\n}\n\n.home-player-goals__badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #0877bc;\n  margin-bottom: 8px;\n}\n\n.home-player-goals__value {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1a2b3c;\n  line-height: 1.4;\n}\n\n.home-player-goals__list {\n  margin: 0;\n  padding-left: 1.1rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.5;\n}\n\n.home-player-goals__list li {\n  margin-bottom: 4px;\n}\n\n.home-role-picker {\n  margin: 0 16px 16px;\n  max-width: 900px;\n}\n\n.home-player-groups {\n  margin: 0 16px 20px;\n  max-width: 900px;\n}\n\n.home-player-groups__title {\n  margin: 0 0 10px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1a2b3c;\n}\n\n.home-player-groups__list {\n  margin: 0;\n  padding-left: 1.25rem;\n  color: #334155;\n  line-height: 1.6;\n}\n\n.home-player-new-session {\n  margin: 0 16px 20px;\n  max-width: 900px;\n  width: calc(100% - 32px);\n  border: 0;\n  border-radius: 16px;\n  padding: 16px 18px;\n  font: inherit;\n  font-weight: 700;\n  color: #fff;\n  background: var(--brand-primary, #0877bc);\n  cursor: pointer;\n  box-shadow: 0 10px 24px -8px color-mix(in srgb, var(--brand-primary, #0877bc) 55%, transparent);\n}\n\n.home-player-new-session:hover {\n  transform: scale(1.01);\n}\n\n.home-player-new-session:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n}\n\n.home-player-next-sessions {\n  margin: 0 16px 20px;\n  max-width: 900px;\n  padding: 16px 18px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.home-player-next-sessions__title {\n  margin: 0 0 12px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1a2b3c;\n}\n\n.home-player-next-sessions__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.home-player-next-sessions__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  margin: 0;\n  padding: 12px 0;\n  border: 0;\n  border-bottom: 1px solid #f1f5f9;\n  background: transparent;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.home-player-next-sessions__item:last-child {\n  border-bottom: none;\n}\n\n.home-player-next-sessions__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.home-player-next-sessions__go {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n}\n\n.home-player-next-sessions__group {\n  font-weight: 600;\n  color: var(--brand-primary, #0877bc);\n}\n\n.home-player-next-sessions__meta {\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.home-player-finalized-calendar {\n  margin-top: 8px;\n}\n\n.home-player-finalized-calendar__hint {\n  margin: 0 16px 12px;\n  max-width: 900px;\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.home-player-finalized {\n  margin: 0 16px 24px;\n  max-width: 900px;\n  padding: 16px 18px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fafafa;\n}\n\n.home-player-finalized__title {\n  margin: 0 0 12px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.home-player-finalized__list {\n  margin: 0;\n  padding-left: 1.1rem;\n  color: #334155;\n}\n\n.home-player-finalized__item {\n  margin-bottom: 8px;\n}\n\n.home-player-finalized__group {\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n.home-player-finalized-hint {\n  margin: 0 16px 16px;\n  max-width: 900px;\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.home-player-finalized__empty,\n.home-player-finalized__loading {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #64748b;\n}\n\n/* Premium Dynamic Bright/Dark theme for all home roles (player, coach, admin) */\n.home-theme-root {\n  --brand-primary: var(--Primary-Color, #0A84FF);\n  position: relative;\n  background: var(--bg-color) !important;\n  color: var(--text-color) !important;\n  min-height: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"SF Pro Display\", \"SF Compact Display\", \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif !important;\n  padding-bottom: 0;\n  transition: background 0.3s ease, color 0.3s ease !important;\n}\n\n/* Soft athletic brand wash behind hero */\n.home-theme-root .home-hero-wash {\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 140px;\n  z-index: 0;\n  background: linear-gradient(\n    165deg,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16) 0%,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04) 45%,\n    transparent 75%\n  );\n}\n\n.dark-mode .home-theme-root .home-hero-wash,\nhtml.dark-mode .home-theme-root .home-hero-wash {\n  background: linear-gradient(\n    165deg,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) 0%,\n    rgba(15, 23, 42, 0.55) 40%,\n    transparent 80%\n  );\n}\n\n.home-theme-root > *:not(.home-hero-wash):not(.home-dashboard-body__overlay) {\n  position: relative;\n  z-index: 1;\n}\n\n/* Header (role switcher + its menu) must paint above the Switch club card. */\n.home-theme-root > .header {\n  z-index: 5;\n  overflow: visible;\n}\n\n.home-theme-root .home-header--compact.header {\n  padding: 10px 12px !important;\n  margin: 6px 8px 4px !important;\n  justify-content: flex-end;\n}\n\n.home-theme-root .home-welcome-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 8px 12px 8px;\n  padding: 8px 12px;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color, rgba(0, 0, 0, 0.08)));\n  background:\n    linear-gradient(\n      120deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent) 0%,\n      transparent 55%\n    ),\n    var(--surface-color, #fff);\n  box-sizing: border-box;\n  animation: homeHeroFadeUp 0.45s cubic-bezier(0.25, 1, 0.5, 1) both;\n}\n\n.home-theme-root .home-welcome-card__copy {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.home-theme-root .home-welcome-card__actions {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 7px;\n}\n\n.home-theme-root .home-welcome-card__eyebrow {\n  margin: 0 !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc) !important;\n  line-height: 1.2 !important;\n}\n\n.home-theme-root .home-welcome-card__name {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--text-color, #111) !important;\n  text-transform: capitalize;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@keyframes homeHeroFadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.home-theme-root h1,\n.home-theme-root h2,\n.home-theme-root h3,\n.home-theme-root h4,\n.home-theme-root h5,\n.home-theme-root h6 {\n  color: var(--text-color) !important;\n  transition: color 0.3s ease !important;\n}\n\n.home-theme-root p {\n  color: var(--text-secondary) !important;\n  transition: color 0.3s ease !important;\n}\n\n/* Navigation Header glass reskin */\n.home-theme-root .header {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 16px !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  padding: 16px 20px !important;\n  margin: 12px 16px 16px !important;\n  color: var(--text-color) !important;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .header-info > h3 {\n  color: var(--text-color) !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n}\n\n.home-theme-root .header-info > h3 span {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .header-info > p {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .clublogo,\n.home-theme-root .header-role-btn {\n  border: 1px solid var(--border-color) !important;\n  background: var(--surface-color) !important;\n  box-shadow: 0 4px 10px var(--shadow-color) !important;\n}\n\n.home-theme-root .header-role-menu,\n.home-theme-root .header-role-menu--portal {\n  z-index: 12050;\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .notification-btn {\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n  color: var(--text-color) !important;\n  transition: all 0.2s ease;\n}\n\n.home-theme-root .notification-btn:hover {\n  background: var(--border-color) !important;\n  border-color: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.4) !important;\n}\n\n/* Material UI Dropdown Role Picker Reskin */\n.home-theme-root .home-role-picker .MuiOutlinedInput-root {\n  color: var(--text-color) !important;\n  border-radius: 12px !important;\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n}\n\n.home-theme-root .home-role-picker .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-color) !important;\n}\n\n.home-theme-root .home-role-picker .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.5) !important;\n}\n\n.home-theme-root .home-role-picker .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .home-role-picker .MuiInputLabel-root {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .home-role-picker .MuiInputLabel-root.Mui-focused {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .home-role-picker .MuiSvgIcon-root {\n  color: var(--text-secondary) !important;\n}\n\n/* Club Strip Card Reskin */\n.home-theme-root .home-club-strip {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  border-radius: 16px !important;\n  margin: 0 16px 16px;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .home-club-strip__logo {\n  border: 1px solid var(--border-color) !important;\n  background: var(--surface-color) !important;\n  padding: 6px !important;\n  box-shadow: 0 4px 12px var(--shadow-color) !important;\n}\n\n.home-theme-root .home-club-strip__label {\n  color: var(--brand-primary, #0A84FF) !important;\n  font-weight: 700;\n}\n\n.home-theme-root .home-club-strip__name {\n  color: var(--text-color) !important;\n}\n\n/* Brand primary can be a dark club color — keep label readable on dark cards */\n.dark-mode .home-theme-root .home-club-strip__label,\nhtml.dark-mode .home-theme-root .home-club-strip__label {\n  color: var(--brand-primary-light, var(--brand-primary, #0A84FF)) !important;\n}\n\n.home-theme-root .home-player-goals__card {\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  box-shadow: 0 8px 24px var(--shadow-color) !important;\n  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.3s ease !important;\n}\n\n.home-theme-root .home-player-goals__card:hover {\n  transform: translateY(-2px);\n}\n\n.home-theme-root .home-player-goals__card--primary {\n  background: linear-gradient(\n    160deg,\n    var(--surface-color) 0%,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) 100%\n  ) !important;\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) !important;\n}\n\n.home-theme-root .home-player-goals__badge {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .home-player-goals__value,\n.home-theme-root .home-player-goals__title,\n.home-theme-root .home-player-goals__list {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .metrics-container {\n  animation: homeMetricsStagger 0.55s cubic-bezier(0.25, 1, 0.5, 1) 0.08s both;\n}\n\n@keyframes homeMetricsStagger {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home-theme-root .home-welcome-card,\n  .home-theme-root .metrics-container {\n    animation: none !important;\n  }\n}\n\n.dark-mode .home-theme-root .home-welcome-card,\nhtml.dark-mode .home-theme-root .home-welcome-card {\n  background:\n    linear-gradient(\n      120deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent) 0%,\n      transparent 55%\n    ),\n    var(--surface-color, #1a1a1a);\n}\n\n/* Player Groups List Badge Capsule Reskin */\n.home-theme-root .home-player-groups {\n  margin: 0 16px 20px;\n}\n\n.home-theme-root .home-player-groups__title {\n  color: var(--text-color) !important;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n\n.home-theme-root .home-player-groups__list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none !important;\n  padding: 0 !important;\n  margin: 12px 0 0 0 !important;\n}\n\n.home-theme-root .home-player-groups__list li,\n.home-theme-root .home-player-groups__card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--surface-color) !important;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0A84FF) 20%, var(--border-color)) !important;\n  color: var(--text-color) !important;\n  font-weight: 650;\n  font-size: 13px;\n  padding: 8px 14px 8px 8px;\n  border-radius: 14px;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0A84FF) 10%, transparent) !important;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.home-player-groups__mark {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 9px;\n  background: linear-gradient(160deg, var(--brand-primary, #0877BC), color-mix(in srgb, var(--brand-primary, #0877BC) 55%, #081018));\n  color: #fff;\n  font-size: 13px;\n  font-weight: 750;\n  text-transform: uppercase;\n}\n\n.home-player-groups__name {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.home-theme-root .home-player-groups__list li:hover,\n.home-theme-root .home-player-groups__card:hover {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--brand-primary, #0A84FF) 45%, var(--border-color)) !important;\n  box-shadow: 0 10px 22px color-mix(in srgb, var(--brand-primary, #0A84FF) 16%, transparent) !important;\n}\n\n/* Year Metrics Slider Reskin */\n.home-theme-root .metrics-info h3 {\n  color: var(--text-color) !important;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.home-theme-root .slideData {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  color: var(--text-color) !important;\n  border-radius: 16px !important;\n  margin: 15px 10px;\n  min-height: 148px !important;\n  box-sizing: border-box;\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n}\n\n.home-theme-root .slideData:hover {\n  transform: translateY(-4px) !important;\n  border-color: var(--brand-primary, #0A84FF) !important;\n  box-shadow: 0 12px 40px 0 var(--shadow-color) !important;\n}\n\n.home-theme-root .metrics-container .slideData h3 {\n  color: var(--text-secondary) !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  letter-spacing: 0.02em !important;\n  line-height: 1.25 !important;\n  min-height: 2.5em;\n  display: flex;\n  align-items: center;\n  word-break: break-word;\n  hyphens: auto;\n}\n\n.home-theme-root .slideData p.card-info-main {\n  color: var(--text-color) !important;\n  font-weight: 800 !important;\n  font-size: 32px !important;\n  letter-spacing: -1px;\n}\n\n.home-theme-root .metric-icon {\n  background: linear-gradient(135deg, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.15) 0%, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.03) 100%) !important;\n  border: 2px solid rgba(var(--brand-primary-rgb, 10, 132, 255), 0.3) !important;\n  box-shadow: 0 4px 15px rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) !important;\n}\n\n.home-theme-root .metric-icon svg {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n/* Slider navigation arrows and dots */\n.home-theme-root .react-slideshow-container .nav:first-of-type,\n.home-theme-root .react-slideshow-container .default-nav:last-of-type {\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 4px 12px var(--shadow-color) !important;\n}\n\n.home-theme-root .react-slideshow-container .nav:first-of-type svg,\n.home-theme-root .react-slideshow-container .default-nav:last-of-type svg {\n  fill: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .react-slideshow-container + .indicators .each-slideshow-indicator::before {\n  background: var(--border-color) !important;\n}\n\n.home-theme-root .react-slideshow-container + .indicators .each-slideshow-indicator.active::before {\n  background: var(--brand-primary, #0A84FF) !important;\n}\n\n/* Training Objectives Cards */\n.home-theme-root .home-player-goals__title {\n  color: var(--text-color) !important;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n\n.home-theme-root .home-player-goals__card {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  border-radius: 16px !important;\n  color: var(--text-color) !important;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .home-player-goals__card--primary {\n  border: 1px solid rgba(var(--brand-primary-rgb, 10, 132, 255), 0.35) !important;\n  background: linear-gradient(160deg, var(--surface-color) 0%, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) 100%) !important;\n  box-shadow: 0 8px 32px 0 rgba(var(--brand-primary-rgb, 10, 132, 255), 0.12) !important;\n}\n\n.home-theme-root .home-player-goals__badge {\n  color: var(--brand-primary, #0A84FF) !important;\n  font-weight: 700;\n  font-size: 11px;\n}\n\n.home-theme-root .home-player-goals__value {\n  color: var(--text-color) !important;\n  font-weight: 600;\n}\n\n.home-theme-root .home-player-goals__list {\n  color: var(--text-color) !important;\n}\n\n/* Material-UI PlayerLastSessionCard Glass Reskin */\n.home-theme-root .MuiCard-root {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  color: var(--text-color) !important;\n  border-radius: 16px !important;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .MuiCard-root > .MuiBox-root:first-of-type {\n  background: linear-gradient(135deg, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.15) 0%, rgba(var(--brand-primary-rgb, 10, 132, 255), 0.05) 100%) !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiTypography-root {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiTypography-caption {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiDivider-root {\n  border-color: var(--border-color) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiIconButton-root {\n  color: var(--text-color) !important;\n  background: var(--bg-color) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiIconButton-root:hover {\n  background: var(--border-color) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiChip-root {\n  background: var(--border-color) !important;\n  color: var(--text-color) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.home-theme-root .MuiCard-root .MuiChip-root[style*=\"color\"] {\n  background: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) !important;\n}\n\n.home-theme-root .MuiCard-root svg {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n/* Next Sessions Section */\n.home-theme-root .home-player-next-sessions {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  border-radius: 16px !important;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .home-player-next-sessions__title {\n  color: var(--text-color) !important;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.home-theme-root .home-player-next-sessions__group {\n  color: var(--brand-primary, #0A84FF) !important;\n  font-weight: 700 !important;\n}\n\n.home-theme-root .home-player-next-sessions__meta {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .home-player-next-sessions__item {\n  border-bottom: 1px solid var(--border-color) !important;\n}\n\n.home-theme-root .home-player-next-sessions__item:hover {\n  color: var(--text-color);\n}\n\n.home-theme-root .home-player-next-sessions__go {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n/* DatePicker Calendar Glass Overrides */\n.home-theme-root .home-player-finalized-calendar__hint {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .home-player-finalized-calendar > div[style*=\"background-color\"] {\n  background-color: var(--surface-color) !important;\n  color: var(--text-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 16px !important;\n}\n\n.home-theme-root .rdrCalendarWrapper {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  border-radius: 16px !important;\n  color: var(--text-color) !important;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .rdrMonthAndYearPickers select {\n  color: var(--text-color) !important;\n  background: transparent !important;\n}\n\n.home-theme-root .rdrMonthAndYearPickers select option {\n  background-color: var(--surface-color) !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .rdrMonthAndYearPickers {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .rdrWeekDay {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .rdrDayNumber span {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .rdrDayPassive .rdrDayNumber span {\n  color: var(--text-secondary) !important;\n  opacity: 0.3 !important;\n}\n\n.home-theme-root .rdrNextPrevButton {\n  background: var(--bg-color) !important;\n}\n\n.home-theme-root .rdrNextButton i {\n  border-color: transparent transparent transparent var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .rdrPprevButton i {\n  border-color: transparent var(--brand-primary, #0A84FF) transparent transparent !important;\n}\n\n.home-theme-root .rdrSelected,\n.home-theme-root .rdrDaySelected {\n  background: var(--brand-primary, #0A84FF) !important;\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .rdrSelected ~ .rdrDayNumber span,\n.home-theme-root .rdrDaySelected .rdrDayNumber span {\n  color: #ffffff !important;\n  font-weight: 700;\n}\n\n/* Sessions Card Overrides under Player Home */\n.home-theme-root .sessionselectedgrp {\n  color: var(--text-color) !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n}\n\n.home-theme-root .sessions-list > li,\n.home-theme-root .sessions-list ul li {\n  background: var(--surface-color) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 8px 32px 0 var(--shadow-color) !important;\n  color: var(--text-color) !important;\n  border-radius: 16px !important;\n  transition: all 0.3s ease !important;\n}\n\n.home-theme-root .sessions-list .session-info h3 {\n  color: var(--text-color) !important;\n  font-weight: 700 !important;\n}\n\n.home-theme-root .sessions-list .session-info p {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .session-start {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .deactive_btn {\n  background-color: #FF453A !important;\n  border-radius: 8px !important;\n}\n\n.home-theme-root .session_edit p {\n  background: var(--bg-color) !important;\n  border: 1px solid var(--border-color) !important;\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .session_edit p:hover {\n  background: var(--border-color) !important;\n  border-color: rgba(var(--brand-primary-rgb, 10, 132, 255), 0.4) !important;\n  box-shadow: 0 4px 15px rgba(var(--brand-primary-rgb, 10, 132, 255), 0.1) !important;\n}\n\n/* State highlights */\n.home-theme-root .sessions-list ul li.home-session-card.scheduled {\n  border-color: var(--border-color) !important;\n  background: var(--surface-color) !important;\n}\n\n.home-theme-root .sessions-list ul li.home-session-card.running {\n  border: 2px solid #30D158 !important;\n  box-shadow: 0 0 15px rgba(48, 209, 88, 0.25) !important;\n}\n\n.home-theme-root .sessions-list ul li.home-session-card.paused {\n  border: 2px solid #FF9F0A !important;\n  box-shadow: 0 0 15px rgba(255, 159, 10, 0.25) !important;\n}\n\n.home-theme-root .sessions-list ul li.home-session-card.finalized {\n  border: 2px solid var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .sessions-list ul li.home-session-card.active,\n.home-theme-root .sessions-list ul li.home-session-card.home-session-card--selected {\n  border: 2px solid var(--brand-primary, #0A84FF) !important;\n  background: color-mix(\n    in srgb,\n    var(--brand-primary, #0A84FF) 18%,\n    var(--surface-color)\n  ) !important;\n  box-shadow:\n    0 0 0 3px color-mix(in srgb, var(--brand-primary, #0A84FF) 40%, transparent),\n    0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 28%, transparent) !important;\n}\n\n/* Shared hint banner above calendar (replaces inline light-gray boxes) */\n.home-date-hint {\n  padding: 15px 20px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin: 0 16px 15px;\n  max-width: 900px;\n  background: var(--surface-color);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: 0 4px 16px var(--shadow-color);\n}\n\n/* Section headings (metrics, training groups, etc.) */\n.home-theme-root .home-info > h3,\n.home-theme-root .metrics-info h3 {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .sessionselectedgrp {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .sessionselectedgrp span {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .slideData p.card-info-unit,\n.home-theme-root .metrics-container .slideData p.update-date {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .slideData:hover .card-info h3,\n.home-theme-root .slideData:hover .card-info p {\n  color: var(--text-color) !important;\n}\n\n/* Training group slider cards */\n.home-theme-root .Groupcard {\n  background: var(--surface-color) !important;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0A84FF) 18%, var(--border-color)) !important;\n  box-shadow: 0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 14%, transparent) !important;\n  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease !important;\n}\n\n.home-theme-root .Groupcard:hover {\n  border-color: color-mix(in srgb, var(--brand-primary, #0A84FF) 42%, var(--border-color)) !important;\n}\n\n.home-theme-root .selectedgrp,\n.home-theme-root .Groupcard.groupcard--selected {\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0A84FF) 55%, var(--border-color)) !important;\n}\n\n.home-theme-root .group_name p {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .groupcard__lane-val {\n  color: var(--text-color);\n}\n\n.home-theme-root .groupcard__lane-lbl {\n  color: var(--text-secondary);\n}\n\n.home-theme-root .groups-slider-container .indicators .each-slideshow-indicator::before {\n  background: color-mix(in srgb, var(--brand-primary, #0A84FF) 35%, var(--border-color)) !important;\n}\n\n.home-theme-root .groups-slider-container .indicators .each-slideshow-indicator.active::before {\n  background: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .ImageOverlay,\n.home-theme-root .groupcard__media {\n  background:\n    radial-gradient(120% 90% at 12% 110%, color-mix(in srgb, var(--brand-primary, #0A84FF) 38%, transparent) 0%, transparent 58%),\n    linear-gradient(165deg, color-mix(in srgb, var(--brand-primary, #0A84FF) 22%, #0b1f33) 0%, #102a44 100%) !important;\n}\n\n.home-theme-root .sliderinfoheading {\n  color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-theme-root .sliderinfosheading {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .sliderinfotheading,\n.home-theme-root .slideInfoPStyle {\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .previmgslider circle,\n.home-theme-root .nextimgslider circle {\n  fill: var(--surface-color) !important;\n  stroke: var(--border-color) !important;\n}\n\n/* Compact coach density: shrink groups + today's sessions above the fold */\n.home-theme-root .metrics {\n  margin: 2px 8px 4px;\n}\n\n.home-theme-root .home-info {\n  padding: 2px 10px 4px;\n}\n\n.home-theme-root .home-info > h3 {\n  font-size: 13px !important;\n  line-height: 20px !important;\n  margin: 0 !important;\n}\n\n.home-theme-root .groups-slider-container {\n  padding: 0 2px 2px;\n}\n\n.home-theme-root .groups-slider-container .Groupcard {\n  margin: 4px 6px;\n}\n\n.home-theme-root .groupcard__body {\n  padding: 10px 12px 10px 14px !important;\n}\n\n.home-theme-root .groupcard__media {\n  min-height: 72px !important;\n  height: 72px !important;\n}\n\n.home-theme-root .calendar-and-add-section {\n  margin: 8px auto 12px;\n}\n\n.home-theme-root .calendar-wrapper {\n  max-width: 420px;\n}\n\n.home-theme-root .date-range-picker__toggle {\n  background:\n    linear-gradient(\n      135deg,\n      color-mix(in srgb, var(--brand-primary, #0877BC) 12%, var(--surface-color)) 0%,\n      var(--surface-color) 72%\n    );\n}\n\n.home-theme-root .date-range-picker__kicker {\n  font-size: 13px !important;\n  line-height: 20px !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .date-range-picker__value {\n  font-size: 13px !important;\n  line-height: 20px !important;\n}\n\n.home-theme-root .hts .home-info {\n  padding: 2px 10px 4px;\n}\n\n.home-theme-root .hts .home-info > h3 {\n  font-size: 13px !important;\n  line-height: 20px !important;\n  margin: 0 !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .hts .hts__count {\n  font-size: 13px !important;\n  line-height: 20px !important;\n}\n\n.home-theme-root .home-date-sessions-with-calendar {\n  width: 100%;\n}\n\n.home-theme-root .today-sessions {\n  margin: 2px 8px !important;\n}\n\n/* Today's training sessions cards (coach/admin) — compact */\n.home-theme-root .today-sessions .slideData.session-card {\n  gap: 10px !important;\n  padding: 10px 12px 10px 96px !important;\n  margin: 6px 6px !important;\n  min-height: 96px !important;\n  height: auto !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent) !important;\n  background-color: var(--surface-color) !important;\n  background-image: url(./assets/training_session_icon.png),\n    linear-gradient(\n      135deg,\n      var(--surface-color) 0%,\n      color-mix(in srgb, var(--brand-primary-rgb, 10, 132, 255) 8%, var(--surface-color)) 100%\n    ) !important;\n  background-size: 84px 100%, cover !important;\n  border: 1px solid var(--border-color) !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .today-sessions .slideData.session-card .session-info.card-info {\n  gap: 2px !important;\n}\n\n.home-theme-root .today-sessions .slideData.session-card .session-info h3 {\n  font-size: 14px !important;\n  margin: 0 0 2px !important;\n  line-height: 1.25 !important;\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .today-sessions .slideData.session-card .session-info p {\n  font-size: 12px !important;\n  margin: 0 !important;\n  line-height: 1.3 !important;\n  color: var(--text-secondary) !important;\n}\n\n.home-theme-root .today-sessions .metrics-info h3,\n.home-theme-root .today-sessions .home-info h3 {\n  color: var(--text-color) !important;\n}\n\n/* Loading / empty states follow active theme */\n.home-theme-root .home-sessions-loading-state {\n  color: var(--text-secondary) !important;\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.home-theme-root .home-sessions-empty-state {\n  color: var(--text-secondary) !important;\n  background: var(--surface-color) !important;\n  border: 1px dashed var(--border-color) !important;\n}\n\n.home-theme-root .home-sessions-loading-spinner {\n  border-color: color-mix(in srgb, var(--text-color) 15%, transparent) !important;\n}\n\n/* Role/refresh loading: overlay the dashboard body only, keep header/club strip */\n.home-theme-root .home-dashboard-body {\n  position: relative;\n  min-height: calc(100dvh - 220px);\n}\n\n.home-theme-root .home-dashboard-body__content {\n  transition: opacity 180ms var(--ease-premium, cubic-bezier(0.16, 1, 0.3, 1));\n}\n\n.home-theme-root .home-dashboard-body.is-loading .home-dashboard-body__content {\n  pointer-events: none;\n}\n\n.home-theme-root .home-dashboard-body.is-loading:not(.has-stale-content) .home-dashboard-body__content {\n  opacity: 0;\n}\n\n.home-theme-root .home-dashboard-body.has-stale-content .home-dashboard-body__content {\n  opacity: 0.45;\n}\n\n.home-theme-root .home-dashboard-body__overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  background: color-mix(in srgb, var(--bg-color, #0b0f19) 86%, transparent);\n  animation: homeOverlayIn 180ms var(--ease-premium, cubic-bezier(0.16, 1, 0.3, 1)) both;\n}\n\n.home-theme-root .home-dashboard-body.is-loading:not(.has-stale-content) .home-dashboard-body__overlay {\n  background: var(--bg-color, #0b0f19);\n}\n\n@keyframes homeOverlayIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
